import { Box } from '@mui/material';

import { normalizeSx } from '@/utils/normalizeSx';

import type { SxProps, Theme } from '@mui/material/styles';

type TagProps = {
  label?: string;
  variant?: 'default' | 'large';
  sx?: SxProps<Theme>;
};

const variantSx: Record<'default' | 'large', SxProps<Theme>> = {
  default: {},
  large: { height: 20, px: '6px', fontSize: 10, fontWeight: 600 }
};

const labelSx: SxProps<Theme> = {
  display: 'block',
  lineHeight: 1,
  position: 'relative',
  top: '1px'
};

export const Tag = ({ label = 'beta', variant = 'default', sx }: TagProps) => {
  return (
    <Box
      sx={[
        {
          backgroundColor: label === 'beta' ? 'gx.actionBarButtonTile' : 'primary.main',
          fontSize: '8px',
          textTransform: 'uppercase',
          display: 'inline-flex',
          justifyContent: 'center',
          alignItems: 'center',
          lineHeight: 1,
          px: '4px',
          minWidth: '36px',
          letterSpacing: 0,
          height: '12px'
        },
        ...normalizeSx(variantSx[variant]),
        ...normalizeSx(sx)
      ]}
    >
      <Box
        component='span'
        sx={labelSx}
      >
        {label}
      </Box>
    </Box>
  );
};
